module.exports = __webpack_public_path__ + "img/3.e2782a42.png";